import * as React from 'react';

import { NodeProps, Position } from '@xyflow/react';
import { Globe } from 'lucide-react';

import { BaseNode } from '../../BaseNode';
import type { ActionNode, NodeVisualDefinition } from '../../types';

import { HttpActionConfigType, getHttpPreviewText } from './schema';

/** Typed node for HTTP action */
type HttpActionNodeType = ActionNode<HttpActionConfigType>;

/** Visual definition for the HTTP Request Action node */
export const httpActionVisualDefinition: NodeVisualDefinition = {
  key: 'HttpRequestAction',
  label: 'HTTP Request',
  description: 'Make an HTTP request to an external API',
  icon: Globe,
  color: 'rust',
  handles: [
    {
      type: 'target',
      position: Position.Top,
      className: 'bg-gray!',
    },
    {
      type: 'source',
      position: Position.Bottom,
      className: 'bg-gray!',
    },
  ],
  getContent: getHttpPreviewText as (config: Record<string, unknown>) => string,
};

/**
 * Visual component for HTTP Request Action nodes on the canvas.
 */
export const HttpActionNode = React.memo<NodeProps<HttpActionNodeType>>(
  (props) => (
    <BaseNode
      {...props}
      definition={httpActionVisualDefinition}
      className="@HttpActionNode"
    />
  ),
);

HttpActionNode.displayName = 'HttpActionNode';
